<template>
  <div class="product">
    <div class="productTop">
      <div
        v-for="(item, i) in productList"
        :key="i"
        @click="toDetail(item, i)"
        :class="['productEvery', { active: productCode == item.code }]"
      >
        {{ item.name }}
      </div>
    </div>
    <div v-if="productCode == 1">
      <div class="Sliceb">
        <div
          :style="{
            position: 'relative',
            width: '100%',
            height: '560px',
            boxSizing: 'border-box',
            padding: '106px 0 0 456px',
            overflow: 'hidden',
            textAlign: 'left',
            background: `#fff url(${require('@/assets/Sliceu18.png')}) center left 100px / 1920px 560px no-repeat`,
          }"
        >
          <div
            style="position: relative; z-index: 2; width: 309px; left: 100px"
          >
            <img
              src="@/assets/icon.png"
              alt=""
              style="width: 86px; height: 86px; margin-bottom: 20px"
            />
            <div
              style="
                font-weight: bold;
                font-size: 32px;
                color: #141414;
                line-height: 36px;
                margin-bottom: 32px;
              "
            >
              民匠有约
            </div>
            <div
              style="
                font-weight: 400;
                font-size: 16px;
                color: #141414;
                line-height: 32px;
              "
            >
              “民匠有约”平台集多种功能于一体，打破了传统劳务市场各环节分散的局面。作业人员可以在平台上实现求职、考勤、培训申请等操作，方便快捷……
            </div>
          </div>
        </div>
      </div>
      <div class="Sliceb1">
        <div v-for="(item, index) in plusList" :key="index" class="every">
          <img :src="item.url" alt="" />
          <div class="tilte">{{ item.tilte }}</div>
          <div>{{ item.text }}</div>
        </div>
      </div>
      <div class="productManage">
        <div class="manageText">
          <img src="@/assets/mjyyIcon.png" alt="" class="manageIcon" />
          <h3>民匠管理</h3>
          <p>
            民匠有约企业管理端小程序，可以进行用工需求发布与管理，根据用工需求和灵活工作者的技能、经验、位置等信息，智能推荐合适人选，根据工时、任务或项目自动计算薪酬……
          </p>
        </div>
        <img src="@/assets/map.png" alt="" class="manageImage" />
      </div>

      <div class="Sliceb1">
        <div v-for="(item, index) in plusList1" :key="index" class="every">
          <img :src="item.url" alt="" />
          <div class="tilte">{{ item.tilte }}</div>
          <div>{{ item.text }}</div>
        </div>
      </div>
    </div>
    <div v-if="productCode == 2"><ProductServiceVue /></div>
  </div>
</template>

<script>
import ProductServiceVue from "./ProductService.vue";
export default {
  components: { ProductServiceVue },
  data() {
    return {
      productCode: 1,
      productList: [
        {
          name: "民匠产品",
          code: 1,
        },
        {
          name: "民匠服务",
          code: 2,
        },
      ],
      plusList: [
        {
          url: require("@/assets/Slices2.png"),
          tilte: "培训考证",
          text: "针对城镇新增劳动力特别是大中专毕业生、农村转移劳动力，以就业为导向，开通了叉车、电气焊等培训项目，考取资质证书，提升技术水平、就业能力和就业收入场",
        },
        {
          url: require("@/assets/Slices1.png"),
          tilte: "接发任务",
          text: "支持企业根据特种作业岗位用工需求在平台积极发单，支持特种作业人才积极接单。实现高效、快捷的人力资源需求信息交互和撮合，促进就业",
        },
        {
          url: require("@/assets/Slices3.png"),
          tilte: "特种作业监管",
          text: "平台协同国家相关部门，针对特种作业企业、设备、人员实现数据监管。企业及人员在平台进行特种作业报备审批，人员与设备实现一机一码、一人一码",
        },
        {
          url: require("@/assets/Slices.png"),
          tilte: "人才数据库",
          text: "建立人才数据库，针对培训、考证及就业的数据资源和分析模型为基础，按照人才的工作种类、岗位、经验、收入和地址等参数，掌握人才就业数据，匹配企业招聘需求",
        },
      ],

      plusList1: [
        {
          url: require("@/assets/Slice15.png"),
          tilte: "在线发单",
          text: "企业可以发布用工需求，包括岗位描述、工作时间、技能要求等，查看、编辑或取消已发布的用工需求。",
        },
        {
          url: require("@/assets/Slice14.png"),
          tilte: "一键结算",
          text: "根据工时、任务或项目自动计算薪酬，支持在线支付和结算，生成薪酬明细，自动扣缴个人所得税，生成税务报表。",
        },
        {
          url: require("@/assets/Slice16.png"),
          tilte: "‌灵活调度",
          text: "根据用工需求和灵活工作者的技能、经验、位置等信息，智能推荐合适人选，企业可以手动选择并安排灵活工作者。",
        },
        {
          url: require("@/assets/Slice13.png"),
          tilte: "合规风控",
          text: "支持企业管理者与灵活工作者之间的实时沟通。确保用工流程符合当地劳动法规定，为灵活工作者提供工伤保险等，降低用工风险。",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    toDetail(item) {
      this.productCode = item.code;
      //   this.$emit("toDetail", this.identification);
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.product {
  display: flex;
  flex-direction: column;
  font-family: PingFang SC, PingFang SC;
}
.productTop {
  display: flex;
  justify-content: center;
  margin-top: 105px;
  .productEvery {
    font-weight: 500;
    font-size: 18px;
    color: #606060;
    line-height: 26px;
    margin-right: 148px;
    cursor: pointer;
    position: relative;
  }
}
.active {
  font-weight: 500 !important;
  font-size: 24px !important;
  color: #141414 !important;
}
.active::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 25%;
  width: 50%;
  height: 4px;
  border-radius: 50px;
  background-color: #1c87ff;
}
.Sliceb {
  background: #fdfdfe;
  font-family: PingFang SC, PingFang SC;
  img {
    width: 100%;
    height: 560px;
  }
}

.productManage {
  height: 560px;
  box-sizing: border-box;
  padding: 92px 0 0;
  display: flex;
  justify-content: center;
  gap: 190px;
  background: #ffffff;
}
.manageText {
  width: 248px;
  text-align: left;
}
.manageIcon {
  width: 60px;
  height: 60px;
  display: block;
  margin-bottom: 20px;
}
.manageText h3 {
  margin: 0 0 30px;
  font-weight: 500;
  font-size: 30px;
  color: #141414;
  line-height: 42px;
}
.manageText p {
  margin: 0;
  font-weight: 400;
  font-size: 16px;
  color: #141414;
  line-height: 32px;
}
.manageImage {
  width: 660px;
  height: 360px;
  display: block;
  object-fit: contain;
}

.Sliceb1 {
  background: #f4f7fc;
  padding: 120px 360px;
  display: flex;

  //   flex-wrap: wrap;
  .every {
    width: 280px;
    // height: 428px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(140, 140, 140, 0.25);
    border-radius: 24px 24px 24px 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #141414;
    line-height: 32px;
    padding: 88px 40px 42px 40px;
    text-align: left;
    position: relative;
    margin-right: 22px;
    .tilte {
      font-weight: 500;
      font-size: 20px;
      color: #141414;
      margin-bottom: 56px;
      text-align: center;
    }
    img {
      width: 136px;
      height: 136px;
      position: absolute;
      top: -78px;
      left: 72px;
    }
  }
}

/* 在小屏幕上使用单列布局 */
@media (max-width: 768px) {
  .Sliceb1 {
    padding: 120px 160px;
    .every {
      img {
        left: 50px;
      }
    }
  }
}
</style>
